import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { Property, PropertyUnit } from '@propertypal/shared/src/types/property';
import WhiteButton from '@propertypal/web-ui/src/buttons/WhiteButton';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import { InfoBox } from '@propertypal/web-ui/src/layout/InfoBox';
import useMediaQuery from '@propertypal/web-ui/src/media-query/useMediaQuery';
import { SubHeading } from '@propertypal/web-ui/src/typography';
import router from 'next/router';
import React, { FunctionComponent, useState } from 'react';
import { MobileBox, MobileTable, Table } from './PropertyUnits.style';

interface Props {
  property: Property;
  hasSitemap: boolean;
  onSiteMapClick: (unit: PropertyUnit) => void;
}

const PropertyUnits: FunctionComponent<Props> = (props) => {
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery({ width: 600 });

  if (!props.property.units || !props.property.development) {
    return null;
  }

  const units = expanded ? props.property.units : props.property.units.slice(0, 5);
  const developmentUrl = props.property.development.path;

  return (
    <InfoBox
      title="Units"
      containerStyle={{ margin: '30px 0' }}
      sideItem={
        <WhiteButton
          className="hide-print"
          containerStyle={{ maxWidth: isMobile ? 220 : 360 }}
          onClick={() => router.push(developmentUrl)}
        >
          View {isMobile ? '' : props.property.development.name} Development
        </WhiteButton>
      }
    >
      {!units.length && (
        <SubHeading align="center" mt={30} mb={30}>
          No units are currently available
        </SubHeading>
      )}

      {!!units.length && (
        <>
          <Table>
            <tbody>
              {units.map((unit) => (
                <tr key={unit.name}>
                  <td>
                    <b>{unit.name}</b>
                    {unit.label ? (
                      <>
                        <br />({unit.label})
                      </>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    <b>{unit.price}</b>
                  </td>
                  <td>{unit.size}</td>
                  {props.hasSitemap && (
                    <td>
                      <button onClick={() => props.onSiteMapClick(unit)} type="button" data-testid="sitemap-btn">
                        View Site Map
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>

          <MobileTable>
            {units.map((unit) => (
              <MobileBox key={unit.name}>
                <h3>{unit.name}</h3>
                {unit.label && <p>({unit.label})</p>}
                <p>{unit.price}</p>
                <p>{unit.size}</p>

                {props.hasSitemap && (
                  <button type="button" onClick={() => props.onSiteMapClick(unit)} data-testid="sitemap-btn">
                    View Site Map
                  </button>
                )}
              </MobileBox>
            ))}
          </MobileTable>
        </>
      )}

      {props.property.units.length > units.length && (
        <div>
          <WhiteButton containerStyle={{ maxWidth: 320, margin: '15px 0' }} onClick={() => setExpanded(true)}>
            View More Units <FontAwesomeIcon icon={faChevronDown} />
          </WhiteButton>
        </div>
      )}
    </InfoBox>
  );
};

export default PropertyUnits;
